// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b51fe0d","239":"159faf19","453":"d2bbbda7","455":"8c9186b4"}[chunkId] + ".chunk.js";
};